import clubsConfig from '../common/clubsConfig.js';

// 1.  Use constants for magic strings:
const BAGATELLE_SLUG = 'bagatelle-los-cabos';
const CRAFT_SLUG = 'craft-los-cabos';
const ROSANEGRA_SLUG = 'rosa-negra-los-cabos';
const TABOO_SLUG = 'taboo-los-cabos';
const ILIOS_SLUG = 'ilios-restaurant-los-cabos';
const CHAMBAO_SLUG = 'chambao-los-cabos';
const FUNKY_SLUG = 'funky-geisha-los-cabos';
const VAQUITA_SLUG = 'la-vaquita-los-cabos';
const MAMAZZITA_SLUG = 'mamazzita-los-cabos';
const SQUID_SLUG = 'el-squid-roe-los-cabos';
const HARRYS_SLUG = 'harrys-los-cabos';
const CRANIA_SLUG = 'crania-los-cabos';
const RIU_SLUG = 'riu-party-los-cabos';
const MANDALA_SLUG = 'mandala-los-cabos';
const TAMARA_SLUG = 'tamara-beach-club-los-cabos';
const CAPRICHO_SLUG = 'capricho-los-cabos';
const NOWHERE_SLUG = 'the-nowhere-bar-los-cabos';
const VELEROS_SLUG = 'veleros-beach-club-los-cabos';
const AMANTE_SLUG = 'amante-los-cabos';
const CRUSH_SLUG = 'crush-nightspot-los-cabos';
const CAMPOMAR_SLUG = 'campomar-restaurant-los-cabos';

/**
 * Extracts the venue from a slug.
 * @param {string} slug - The slug string (e.g., 'vagalume-tulum').
 * @returns {string} The venue name, or an empty string if no slug.
 */
function slugDecoder(slug) {
  return slug ? slug.split('-')[0] : '';
  // return slug;
}

/**
 * Decodes a venue title to retrieve venue data from clubsConfig.
 * @param {string} title - The venue title string.
 * @returns {object} The corresponding venue object from clubsConfig, or an object with the original title if not found.
 */
function venueDecoder(slugOrTitle) {
  let venue = '';
  if (slugOrTitle.indexOf('@') > -1) {
    venue = slugOrTitle.split('@')[1];
  } else {
    return clubsConfig[slugOrTitle];
  }

  const venueMatch = venue.toLowerCase().replace('los cabos', '');
  const venueConfigMap = {
    bagatelle: BAGATELLE_SLUG,
    // 'rosanegra': ROSANEGRA_BEACH_SLUG,
    'rosa.+negra': ROSANEGRA_SLUG,
    taboo: TABOO_SLUG,
    crania: CRANIA_SLUG,
    craft: CRAFT_SLUG,
    harrys: HARRYS_SLUG,
    'hotel.+riu|riu.+party': RIU_SLUG,
    tamara: TAMARA_SLUG,
    ilios: ILIOS_SLUG,
    chambao: CHAMBAO_SLUG,
    funky: FUNKY_SLUG,
    mandala: MANDALA_SLUG,
    squid: SQUID_SLUG,
    vaquita: VAQUITA_SLUG,
    nowhere: NOWHERE_SLUG,
    capricho: CAPRICHO_SLUG,
    veleros: VELEROS_SLUG,
    amante: AMANTE_SLUG,
    crush: CRUSH_SLUG,
    campomar: CAMPOMAR_SLUG,
    // parole: PAROLE_SLUG,
    mamazzita: MAMAZZITA_SLUG,
    // tora: TORA_SLUG,
  };

  for (const key in venueConfigMap) {
    if (venueMatch.match(key)) {
      return clubsConfig[venueConfigMap[key]];
    }
  }
  return { title: '', slug: '', name: '', address: {} };
}

export { venueDecoder, slugDecoder };
